import styled from 'styled-components';
import { Button } from "@material-ui/core";
import {
    AssignmentOutlined as AssignmentOutlinedIcon,
    InfoOutlined as InfoOutlinedIcon,
    WorkOutline as WorkOutlineIcon,
    DescriptionOutlined as DescriptionOutlinedIcon,
    ExpandMoreOutlined as ExpandMoreOutlinedIcon,
    ThumbUpAltOutlined as ThumbUpAltOutlinedIcon,
    ThumbDownAltOutlined as ThumbDownAltOutlinedIcon
} from '@material-ui/icons';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';

import { ApplicationsListItem } from "components/ApplicationsList";
import {CrossButtonBlack} from "components/Buttons/CrossButton";

export const Container = styled.div`
  padding: 1rem 1rem 1rem 1.5rem; /* More padding on the left */
  background-color: #fff;
  box-sizing: border-box;
  
  @media (max-width: 465px) {
    padding: 1rem 0.75rem 1rem 1rem; /* Adjusted for mobile */
  }
`

export const StyledApplicationsListItem = styled(ApplicationsListItem)`
  border-bottom: none;
`

export const CandidateDetailsContainer = styled.div`
  margin-top: 1.5rem;
  padding: 1.275rem 1rem;
  border-radius: 8px;
  background-color: #F3F6F7;
`

export const ScoreSection = styled.div<{$score?: number}>`
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 1rem;
  border-radius: 6px;
  margin-bottom: 1.275rem;
  position: relative;
  
  box-shadow: ${({ $score }) => {
    let borderColor = '#e0e0e0';
    if ($score !== undefined) {
      if ($score >= 60) borderColor = '#13CA82';
      else if ($score >= 40) borderColor = '#FFC107';
      else borderColor = '#FB7672';
    }
    return `inset 0 0 0 4px ${borderColor}, 0 1px 3px rgba(0,0,0,0.07)`;
  }};
`

export const ScoreContainer = styled.div`
  display: flex;
  align-items: center;
`

export const Score = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  color: #000;
  font-size: 1.875rem;
  font-weight: 600;

  @media (max-width: 465px) {
    min-width: auto;
    font-size: 1.5rem;
  }
`

export const ScoreLabel = styled.div`
  margin-left: 1rem;
  color: #000;
  font-size: 1.25rem;
  font-weight: 600;
  
  @media (max-width: 465px) {
    font-size: 0.875rem;
  }
`

export const MatchScoreTooltipLink = styled.a`
  font-size: 0.75rem; 
  color: #0B4598;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 1rem;
  margin-top: 2px;
  background: none;
  border: none;
  padding: 0;
  display: inline;

  &:hover {
    text-decoration: none;
  }
`;

export const InfoButton = styled.div`
  display: flex;
  margin-left: 1rem;
`

export const StyledInfoOutlinedIcon = styled(InfoOutlinedIcon)`
  width: 20px !important;
  height: 20px !important;
  color: rgba(0, 0, 0, 0.56);
`

export const InfoSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.275rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`

export const InfoSectionContent = styled.div`
  margin-left: 1rem;
`

export const InfoSectionItemTitle = styled.div`
  margin-bottom: 0.25rem;
  color: #000;
  opacity: 60%;
  font-size: 0.8rem;
  line-height: 1.4;
  font-weight: 700;
`

export const StyledWorkOutlineIcon = styled(WorkOutlineIcon)`
  margin-right: 1rem;
  color: var(--primary-main, #0B4598);
`;

export const StyledAssignmentOutlinedIcon = styled(AssignmentOutlinedIcon)`
  margin-right: 1rem;
  color: var(--primary-main, #0B4598);
`;

export const StyledThumbUpAltOutlinedIcon = styled(ThumbUpAltOutlinedIcon)`
  color: var(--primary-main, #FB7672);
`;

export const StyledThumbDownAltOutlinedIcon = styled(ThumbDownAltOutlinedIcon)`
  color: var(--primary-main, #FB7672);
`;

export const CheckboxContainer = styled.div`
  margin: 1.5rem 0;
`;

export const CheckboxLabel = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-size: 1rem;
  
  @media (max-width: 465px) {
    font-size: 0.75rem;
  }
`

export const ButtonsContainer = styled.div`
  position: relative;
  margin-bottom: 1rem;

  /* T2-6572: Candidate Overview actions should be compact, not full-bleed.
     Global .bigButtonInNewStyle forces width:100% — override only here. */
  .bigButtonInNewStyle {
    width: auto !important;
    min-width: 12rem;
    max-width: 100%;
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
`;

export const ButtonsRowContainer = styled(ButtonsContainer)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  /* T2-6572 follow-up: inherited margin:auto on flex children pushes Shortlist /
     Decline to opposite edges. Keep them adjacent in the center. */
  .bigButtonInNewStyle {
    flex: 0 1 auto;
    min-width: 10rem;
    max-width: 14rem;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
`;

export const StyledDescriptionOutlinedIcon = styled(DescriptionOutlinedIcon)`
  color: #0B4598;
`

export const StyledDescriptionOutlinedIconWhite = styled(DescriptionOutlinedIcon)`
  color: #fff;
`

export const StyledExpandMoreOutlinedIcon = styled(ExpandMoreOutlinedIcon)`
  color: #fff;
`

export const ResumeButton = styled(Button)`
  color: #0B4598 !important;
  border-color: #0B4598 !important;
`

export const PopupContainer = styled.div`
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background: white;
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.75rem;
`

export const PopupTitle = styled.div`
  width: 100%;
  text-align: center;
  font-size: 1.2rem;
  line-height: 1.4;
  font-weight: 600;

  @media (max-width: 465px) {
    font-size: 1rem;
  }
`

export const StyledCrossButtonBlack = styled(CrossButtonBlack)`
  width: 1rem;
`

export const PopupDescription = styled.div`
  margin-bottom: 1.75rem;
  line-height: 1.5;
  white-space: pre-line;
`

export const PopupButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const PopupButton = styled(Button)`
  flex-grow: 1;
  flex-basis: 0;
  margin: 0 4px !important;

  &:first-child {
    margin-left: 0 !important;
  }
  &:last-child {
    margin-right: 0 !important;
  }
`

export const PopupLink = styled.div`
  color: #0B4598;
`

export const Description = styled.div`
  padding-top: 1rem;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.875rem;
`;

export const SkillsTitle = styled.div`
  padding: 1rem 0.5rem 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
`;

export const SkillsContainer = styled.div`
  padding: 0 0.5rem;
`;

export const SkillsLabel = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.875rem;
`;

export const WorkExperienceContainer = styled.div`
  padding: 0 0.5rem;
`;

export const WorkExperienceEntry = styled.div`
  margin-bottom: 1rem;
`;

export const JobTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
`;

export const JobDates = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
`;

export const CompanyName = styled(JobDates)`
  margin-bottom: 0.25rem;
`;

export const StyledNearMeOutlinedIcon = styled(NearMeOutlinedIcon)`
  margin-right: 1rem;
  color: var(--primary-main, #0B4598);
`;

